/* Shared local arrow artwork. Controls and their event listeners stay intact. */
(() => {
  const NS = 'http://www.w3.org/2000/svg';
  const line = 'M3.5 13.2C9.7 12.6 17.1 13.7 23 12.8M8.8 8.6Q6.6 11 3.5 13.2Q5.9 15.2 9 17.6';
  const rotation = {left:0, right:180, up:90, down:-90, external:135, 'up-right':135, 'up-left':45, 'down-right':225, 'down-left':-45};
  const glyphs = {'←':'left','→':'right','↑':'up','↓':'down','↗':'external','↖':'up-left','↘':'down-right','↙':'down-left','‹':'left','›':'right','❮':'left','❯':'right','⌄':'down','⌃':'up','➜':'right','➔':'right','➞':'right','⟶':'right','⟵':'left'};
  const known = new Map([
    ['M4 12h15m-5-6 6 6-6 6','right'],
    ['M4 10h11M11 6l4 4-4 4','right'],
    ['M5 19 19 5M9 5h10v10','external'],
    ['m9 5 7 7-7 7','right'],
    ['m7 10 5 5 5-5','down'],
    ['M5 12h14m-6-6 6 6-6 6','right'],
    ['M4 12h16M14 6l6 6-6 6','right'],
    ['M6 9l6 6 6-6','down'],
    ['m6 9 6 6 6-6','down'],
    ['M9 5l7 7-7 7','right'],
    ['m15 18-6-6 6-6','left'],
    ['m9 18 6-6-6-6','right']
    ,['m14 6-6 6 6 6','left']
    ,['m10 6 6 6-6 6','right']
  ].map(([d,dir])=>[d.replace(/[\s,]+/g,''),dir]));

  function paint(svg, direction) {
    if (svg.dataset.localArrow === direction) return;
    svg.dataset.localArrow = direction;
    svg.setAttribute('viewBox','0 0 26 26');
    svg.setAttribute('focusable','false');
    const path=document.createElementNS(NS,'path');
    path.setAttribute('d',line);
    path.setAttribute('fill','none');
    path.setAttribute('stroke','currentColor');
    path.setAttribute('stroke-width','2.25');
    path.setAttribute('stroke-linecap','round');
    path.setAttribute('stroke-linejoin','round');
    path.setAttribute('transform',`rotate(${rotation[direction] ?? 180} 13 13)`);
    // Keep a title if the original SVG is itself the accessible control label.
    [...svg.children].forEach(child=>{if(!['title','desc'].includes(child.localName))child.remove();});
    svg.append(path);
  }
  function inspect(svg) {
    if(svg.hasAttribute('data-local-arrow'))return;
    let direction=svg.getAttribute('data-cabane-arrow');
    if(!direction && svg.children.length===1 && svg.firstElementChild.localName==='path')
      direction=known.get((svg.firstElementChild.getAttribute('d')||'').replace(/[\s,]+/g,''));
    if(!direction && svg.matches('.icon-caret,.cb__chevron,.preview-category-chevron'))direction='down';
    if(!direction && svg.matches('.icon-arrow,.ac-cta-arrow'))direction='right';
    if(direction && direction in rotation)paint(svg,direction);
  }
  function convertText(root) {
    const walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT);
    const matches=[];
    while(walker.nextNode()) {
      const node=walker.currentNode;
      if(!/[←→↑↓↗↖↘↙‹›❮❯⌄⌃➜➔➞⟶⟵]/.test(node.data))continue;
      if(node.parentElement?.closest('svg,script,style,textarea,select,option,[contenteditable],pre,code'))continue;
      matches.push(node);
    }
    for(const node of matches) {
      const fragment=document.createDocumentFragment();
      for(const part of node.data.split(/([←→↑↓↗↖↘↙‹›❮❯⌄⌃➜➔➞⟶⟵])/)) {
        if(!glyphs[part]){fragment.append(document.createTextNode(part));continue;}
        const svg=document.createElementNS(NS,'svg');
        svg.setAttribute('class','local-arrow-inline');svg.setAttribute('aria-hidden','true');
        paint(svg,glyphs[part]);fragment.append(svg);
      }
      node.replaceWith(fragment);
    }
  }
  function scan(root) {
    if(root.nodeType!==1)return;
    if(root.matches('svg'))inspect(root);
    root.querySelectorAll('svg').forEach(inspect);
    if(!root.closest('svg,script,style'))convertText(root);
  }
  const start=()=>{
    scan(document.body);
    new MutationObserver(records=>{
      const roots=new Set();
      for(const record of records)for(const node of record.addedNodes){
        const root=node.nodeType===1?node:node.parentElement;
        if(root&&!root.closest('svg,script,style'))roots.add(root);
      }
      for(const root of roots)if(root.isConnected)scan(root);
    }).observe(document.body,{childList:true,subtree:true});
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
